/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = System
 *
 * 1 = Default
 *
 * 2 = Individual
 */
export enum EmployeeWorkPatternType {
  System = 0,
  Default = 1,
  Individual = 2,
}
